document.addEventListener('DOMContentLoaded', function () {
  const slider = document.querySelector('ul.pill-list__container');
  if (!slider) return;

  const links = slider.querySelectorAll('a');
  const currentUrl = window.location.pathname;

  let targetLink = null;

  links.forEach((link) => {
    if (link.getAttribute('href') === currentUrl) {
      targetLink = link;
    }
    link.addEventListener('dragstart', (e) => e.preventDefault());
  });

  if (!document.getElementById('pill-list-drag-styles')) {
    const style = document.createElement('style');
    style.id = 'pill-list-drag-styles';
    style.innerHTML = `
      .pill-list__container.is-dragging {
        scroll-snap-type: none !important;
        scroll-behavior: auto !important;
      }
      .pill-list__container.is-dragging .slider__slide {
        scroll-snap-align: none !important;
      }
    `;
    document.head.appendChild(style);
  }

  if (targetLink) {
    const targetItem = targetLink.closest('li');
    const targetOffset = targetItem.offsetLeft - slider.offsetLeft;

    slider.scroll({
      top: 0,
      left: targetOffset,
      behavior: 'smooth',
    });
  }

  let wheelTimeout;
  slider.addEventListener(
    'wheel',
    function (e) {
      if (e.deltaY !== 0) {
        const canScrollRight = slider.scrollLeft < slider.scrollWidth - slider.clientWidth;
        const canScrollLeft = slider.scrollLeft > 0;

        if (canScrollRight || canScrollLeft) {
          e.preventDefault();

          slider.classList.add('is-dragging');

          slider.scrollTo({
            left: slider.scrollLeft + e.deltaY * 2,
            behavior: 'smooth',
          });

          clearTimeout(wheelTimeout);
          wheelTimeout = setTimeout(() => {
            slider.classList.remove('is-dragging');
          }, 150);
        }
      }
    },
    { passive: false }
  );

  let isDown = false;
  let startX;
  let scrollLeft;
  let isDragging = false;

  let velocity = 0;
  let previousX = 0;
  let momentumID = null;
  let lastTime = 0;

  slider.style.cursor = 'grab';

  const beginMomentumTracking = function () {
    if (momentumID) cancelAnimationFrame(momentumID);
    slider.classList.add('is-dragging');
  };

  const applyMomentum = function () {
    if (!isDown) {
      velocity *= 0.92;

      if (Math.abs(velocity) > 0.5) {
        slider.scrollLeft -= velocity;
        momentumID = requestAnimationFrame(applyMomentum);
      } else {
        velocity = 0;
        slider.classList.remove('is-dragging');
      }
    }
  };

  slider.addEventListener('mousedown', (e) => {
    isDown = true;
    isDragging = false;
    slider.style.cursor = 'grabbing';
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
    previousX = e.pageX;
    lastTime = Date.now();
    beginMomentumTracking();
  });

  slider.addEventListener('mouseleave', () => {
    if (!isDown) return;
    isDown = false;
    slider.style.cursor = 'grab';
    momentumID = requestAnimationFrame(applyMomentum);
  });

  slider.addEventListener('mouseup', () => {
    if (!isDown) return;
    isDown = false;
    slider.style.cursor = 'grab';

    if (Math.abs(velocity) <= 0.5) {
      slider.classList.remove('is-dragging');
    }

    momentumID = requestAnimationFrame(applyMomentum);
  });

  slider.addEventListener('mousemove', (e) => {
    if (!isDown) return;

    e.preventDefault();

    const x = e.pageX - slider.offsetLeft;
    const walk = x - startX;

    if (Math.abs(walk) > 3) {
      isDragging = true;
    }

    const now = Date.now();
    const dt = now - lastTime;
    if (dt > 0) {
      velocity = ((e.pageX - previousX) / dt) * 15;
    }

    slider.scrollLeft = scrollLeft - walk;

    previousX = e.pageX;
    lastTime = now;
  });

  slider.addEventListener('click', (e) => {
    if (isDragging || Math.abs(velocity) > 2) {
      e.preventDefault();
      e.stopPropagation();
      isDragging = false;
    }
  });
});
